import axiosApi from '@/api/axiosApi';
import db from '@/utils/localstorage';
import i18n, {getLanguage} from '@/lang';
import {Base64} from 'js-base64';
import { method } from 'lodash';



const baseURL = window.location.origin + process.env.VUE_APP_BASE_API

const baseFetch = (option) => {

    let optionHeaders = {}
    if (option.headers) {
        optionHeaders = option.headers
    }

    let url = option.url
    let method = option.method
    let headers = {
        'Content-Type': 'application/json',
        ...optionHeaders
    }
    let keepalive = option.keepalive || false

    headers['x-language'] = 'en';
    headers.channel = 'app';
    //请求中是否需要token
    const isToken = headers['X-isToken'] === false ? headers['X-isToken'] : true;
    //默认值test主要是为了文件下载
    const token = db.get('CLIENT_TOKEN', 'tourist');
    if (isToken) {
        headers['token'] = 'Bearer ' + token;
    }
    //请求头是否需要tenant租户
    const isTenant = headers['X-isTenant'] === false ? headers['X-isTenant'] : true;
    if (isTenant && process.env.VUE_APP_IS_MULTI_TENANT_TYPE !== "NONE") {
        headers['tenant'] = db.get('CLIENT_TENANT', 'cGFydG5lcg==')
    }
    if (isToken) {
        headers['Authorization'] = 'Basic bGFtcF93ZWI6bGFtcF93ZWJfc2VjcmV0';
    } else {
        const clientId = process.env.VUE_APP_CLIENT_ID;
        const clientSecret = process.env.VUE_APP_CLIENT_SECRET;
        headers['Authorization'] = `Basic ${Base64.encode(`${clientId}:${clientSecret}`)}`;
    }


    let body = JSON.stringify(option.data)
    let mode = 'cors' || option.mode

    let params = new URLSearchParams({
        ts: Date.now(),
        language: getLanguage()
    })

    return fetch(`${baseURL + url}?${params.toString()}`, {
        method,
        headers,
        body,
        keepalive
    })
}


export const putQuestion = (data) => baseFetch({
    method: 'POST',
    url: '/intserv/ai/putQuestion',
    data,
    headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
    }
})

export const createChatId = () => axiosApi({
    method: 'GET',
    url: '/intserv/ai/createChatId'
})

export const getChatListById = () => axiosApi({
    method: 'GET',
    url: '/intserv/ai/getChatListById'
})

export const getMessageListByChatId = (data) => axiosApi({
    method: 'GET',
    url: `/intserv/ai/getMessageListByChatId/${data}`
})

export const deleteChat = (data) => axiosApi({
    method: 'POST',
    url: '/intserv/ai/deleteChat',
    data
})